import SvgIcon from '@mui/material/SvgIcon'
import useStyles from './FilterIcon.styles'

const FilterIcon = ({
    className = '',
}: Readonly<{
    className?: string,
}>) => {
    const {
        classes,
        cx,
    } = useStyles()

    return (
        <SvgIcon
            className={cx(classes.icon, className)}
            viewBox="0 0 15 15"
        >
            <path
                d="M2 2.054464L15.230225 2l-5.132897 4.825055-.123136 8.311554-3.318686-2.544346.142712-5.715111z"
            />
        </SvgIcon>
    )
}

export default FilterIcon
